import axios from "axios";
import Cookies from "js-cookie";
import toast from "react-hot-toast";

export const isLoggedIn = () => {
  return Cookies.get(`${process.env.REACT_APP_NETWORK}__admin__authToken`);
};
// const getUserToken = () => {
//   if (Cookies.get("accessToken")) {
//     return Cookies.get("accessToken");
//   } else return false;
// };

const getUserToken = () => {
  const currentUser = sessionStorage.getItem("referredAs");
  if (currentUser == "User") {
    return Cookies.get("accessToken");
  } else {
    return Cookies.get("pfaccessToken");
  }
};

export const showErrorMessage = (message) => {
  if (message instanceof Array) {
    message.forEach((msg) => toast.error(msg));
  } else {
    toast.error(message);
  }
};

const responseFormatter = (status, data, error) => {
  return { status, data: data || null, error };
};

const handleApiError = (err) => {
  return responseFormatter(false, null, err.response?.data);
};

export const postReq = async (endpoint, data) => {
  const url = process.env.REACT_APP_DEV_API + endpoint;
  const headers = {
    Accept: "application/json"
    // Authorization: `Bearer ${getUserToken()}`,
  };
  return await axios
    .post(url, data, { withCredentials: true, headers })
    .then((response) => {
      return responseFormatter(true, response.data, null);
    })
    .catch((err) => {
      return handleApiError(err);
    });
};
export const postAuthReq = async (endpoint, data) => {
  const url = process.env.REACT_APP_DEV_API + endpoint;
  const headers = {
    Accept: "application/json",
    Authorization: `Bearer ${getUserToken()}`
  };
  return await axios
    .post(url, data, { withCredentials: true, headers })
    .then((response) => {
      return responseFormatter(true, response.data, null);
    })
    .catch((err) => {
      console.log(err, "err");
      return handleApiError(err);
    });
};

export const patchReq = async (endpoint, data) => {
  const url = process.env.REACT_APP_DEV_API + endpoint;

  const headers = {
    Accept: "application/json",
    Authorization: `Bearer ${getUserToken()}`
  };

  return await axios
    .patch(url, data, { withCredentials: true, headers })
    .then((response) => {
      return responseFormatter(true, response.data, null);
    })
    .catch((err) => {
      return handleApiError(err);
    });
};
export const putReq = async (endpoint, data) => {
  const url = process.env.REACT_APP_DEV_API + endpoint;

  const headers = {
    Accept: "application/json",
    Authorization: `Bearer ${getUserToken()}`
  };

  return await axios
    .put(url, data, { withCredentials: true, headers })
    .then((response) => {
      return responseFormatter(true, response.data, null);
    })
    .catch((err) => {
      return handleApiError(err);
    });
};

export const getWReq = async (endpoint) => {
  const baseUrl = process.env.REACT_APP_WEB_API_URL || "https://cms.mstblockchain.com";
  console.log("getWReq using Base URL:", baseUrl, "| Env variable was:", process.env.REACT_APP_WEB_API_URL);
  const url = baseUrl + endpoint;

  return await axios
    .get(url, { withCredentials: true })
    .then((response) => {
      return responseFormatter(true, response.data, null);
    })
    .catch((err) => {
      return handleApiError(err);
    });
};

export const getScannerDataReq = async (endpoint) => {
  const url = process.env.REACT_APP_MSTSCAN_API_URL + endpoint;
  const headers = {
    Accept: "application/json"
    // Authorization: `Bearer ${getUserToken()}`,
  };
  return await axios
    .get(url, { headers })
    .then((response) => {
      return responseFormatter(true, response.data, null);
    })
    .catch((err) => {
      return handleApiError(err);
    });
};

export const getReq = async (endpoint) => {
  const url = process.env.REACT_APP_DEV_API + endpoint;

  const headers = {
    Accept: "application/json"
    // Authorization: `Bearer ${getUserToken()}`,
  };

  return await axios
    .get(url, { withCredentials: true, headers })
    .then((response) => {
      return responseFormatter(true, response.data, null);
    })
    .catch((err) => {
      return handleApiError(err);
    });
};

export const getScannerReq = async (endpoint) => {
  const url = process.env.REACT_APP_SCANNER_DEV_API + endpoint;
  const headers = {
    Accept: "application/json"
    // Authorization: `Bearer ${getUserToken()}`,
  };
  return await axios
    .get(url, { withCredentials: true, headers })
    .then((response) => {
      return responseFormatter(true, response.data, null);
    })
    .catch((err) => {
      return handleApiError(err);
    });
};

export const deleteReq = async (endpoint) => {
  const url = process.env.REACT_APP_DEV_API + endpoint;

  const headers = {
    Accept: "application/json",
    Authorization: `Bearer ${getUserToken()}`
  };

  return await axios
    .delete(url, { withCredentials: true, headers })
    .then((response) => {
      return responseFormatter(true, response.data, null);
    })
    .catch((err) => {
      return handleApiError(err);
    });
};

export const postFile = async (endpoint, data) => {
  const url = process.env.REACT_APP_DEV_API + endpoint;
  const headers = {
    Accept: "application/json",
    Authorization: `Bearer ${getUserToken()}`,
    "Content-Type": "multipart/form-data"
  };

  try {
    const response = await axios.post(url, data, {
      withCredentials: true,
      headers
    });
    return responseFormatter(true, response.data, null);
  } catch (err) {
    return handleApiError(err);
  }
};

export const getAuthReq = async (endpoint) => {
  const url = process.env.REACT_APP_DEV_API + endpoint;

  const headers = {
    Accept: "application/json",
    Authorization: `Bearer ${getUserToken()}`
  };

  return await axios
    .get(url, { withCredentials: true, headers })
    .then((response) => {
      return responseFormatter(true, response.data, null);
    })
    .catch((err) => {
      return handleApiError(err);
    });
};
// export const getChapterFiveData = async () => {
//   try {
//     const res = await getReq('/how-it-works?populate=*');
//     return res;
//   } catch (error) {
//     throw error;
//   }
// };
// export const getEsimation = async (endpoint) => {
//   try {
//     const res = await getReq('/estimation/quick/public?*');
//     return res;
//   } catch (error) {
//     throw error;
//   }
// };
export const getEsimation = async (endpoint) => {
  const url = process.env.API_URL_ESTIMATATION + endpoint;
  // const headers = {
  //   Accept: 'application/json',
  // };

  return await axios
    .get(url, { withCredentials: true })
    .then((response) => {
      return responseFormatter(true, response.data, null);
    })
    .catch((err) => {
      return handleApiError(err);
    });
};
export const getCurrency = async (endpoint) => {
  const url = process.env.REACT_APP_CURRENCY_API + endpoint;
  return await axios
    .get(url, { withCredentials: true })
    .then((response) => {
      return responseFormatter(true, response.data, null);
    })
    .catch((err) => {
      return handleApiError(err);
    });
};

export const daoPostReq = async (endpoint, data) => {
  const url = process.env.REACT_APP_DAO_API_URL + endpoint;
  const headers = {
    Accept: "application/json"
    // Authorization: `Bearer ${getUserToken()}`,
  };
  return await axios
    .post(url, data, { withCredentials: true, headers })
    .then((response) => {
      return responseFormatter(true, response.data, null);
    })
    .catch((err) => {
      return handleApiError(err);
    });
};

export const daoGetReq = async (endpoint) => {
  const url = process.env.REACT_APP_DAO_API_URL + endpoint;
  const headers = {
    Accept: "application/json"
    // Authorization: `Bearer ${getUserToken()}`,
  };
  return await axios
    .get(url, { withCredentials: true, headers })
    .then((response) => {
      return responseFormatter(true, response.data, null);
    })
    .catch((err) => {
      return handleApiError(err);
    });
};

export const daoPatchReq = async (endpoint, data) => {
  const url = process.env.REACT_APP_DAO_API_URL + endpoint;
  const headers = {
    Accept: "application/json"
    // Authorization: `Bearer ${getUserToken()}`
  };
  return await axios
    .patch(url, data, { withCredentials: true, headers })
    .then((response) => {
      return responseFormatter(true, response.data, null);
    })
    .catch((err) => {
      return handleApiError(err);
    });
};

export const daoDeleteReq = async (endpoint) => {
  const url = process.env.REACT_APP_DAO_API_URL + endpoint;
  const headers = {
    Accept: "application/json"
  };
  return await axios
    .delete(url, { withCredentials: true, headers })
    .then((response) => {
      return responseFormatter(true, response.data, null);
    })
    .catch((err) => {
      return handleApiError(err);
    });
};

export const imageUrl = "https://ik.imagekit.io/avboeabnm1/";

// previous-
// export function getImageUrl(path) {
//   if (!path) return path;
//   if (
//     path.startsWith("/public") &&
//     process.env.REACT_APP_IMAGE_KIT === "notactive"
//   ) {
//     path = path.replace("/public", "");
//   }
//   if (process.env.REACT_APP_IMAGE_KIT === "notactive") {
//     return path;
//   }
//   if (process.env.REACT_APP_IMAGE_KIT === "active") {
//     return `${imageUrl}${
//       path.startsWith("/") ? `${path}?tr=q-80` : "/" + `${path}?tr=q-80`
//     }`;
//   }
// }

export function getImageUrl(path) {
  if (!path) return "";

  const mode = process.env.REACT_APP_IMAGE_KIT || "notactive";

  if (path.startsWith("/public") && mode === "notactive") {
    path = path.replace("/public", "");
  }

  if (mode === "notactive") {
    return path;
  }

  if (mode === "active") {
    return `${imageUrl}${path.startsWith("/") ? `${path}?tr=q-80` : `/${path}?tr=q-80`
      }`;
  }
  return path;
}

export const postContactReq = async (endpoint, data) => {
  const base = process.env.REACT_APP_DEV_API;

  try {
    const response = await axios.post(`${base}${endpoint}`, data, {
      withCredentials: false,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      }
    });
    // return a consistent shape
    return { ok: true, data: response.data };
  } catch (err) {
    const status = err.response?.status;
    const apiMsg =
      err.response?.data?.message ||
      err.response?.data?.error ||
      err.response?.data?.msg;
    const message = apiMsg || err.message || "Request failed";
    return { ok: false, status, message, data: err.response?.data };
  }
};
